import * as XLSX from "xlsx";
import { monthLabel } from "@/lib/format";

function autoWidths(rows, headers) {
  return headers.map((h) => {
    let max = h.length;
    rows.forEach((r) => {
      const v = r[h];
      const len = v === null || v === undefined ? 0 : String(v).length;
      if (len > max) max = len;
    });
    return { wch: Math.min(Math.max(max + 2, 10), 40) };
  });
}

export function exportLeadsToExcel({ rows, filters = {}, generatedBy = "" }) {
  const wb = XLSX.utils.book_new();

  // --- Report Info sheet ---
  let periodText = "All time";
  if (filters.month) periodText = monthLabel(filters.month);
  else if (filters.date_from || filters.date_to)
    periodText = `${filters.date_from || "start"} to ${filters.date_to || "today"}`;

  const info = [
    ["RVSF CRM — Leads Report"],
    [],
    ["Report Period", periodText],
    ["Generated On", new Date().toLocaleString("en-IN")],
    ["Generated By", generatedBy || ""],
    ["Total Records", rows.length],
    [],
    ["Applied Filters"],
    ["Employee", filters.employeeName || "All employees"],
    ["Lead Type", filters.leadTypeLabel || "All types"],
    ["Lead Status", filters.statusLabel || "All statuses"],
    ["Deal Processing", filters.dealStatusLabel || "All"],
  ];
  const ws1 = XLSX.utils.aoa_to_sheet(info);
  ws1["!cols"] = [{ wch: 22 }, { wch: 42 }];
  XLSX.utils.book_append_sheet(wb, ws1, "Report Info");

  // --- Leads sheet ---
  const headers = rows.length
    ? Object.keys(rows[0])
    : [
        "Lead ID", "Lead Type", "Employee", "Dealership", "Customer Name", "Mobile",
        "Vehicle Number", "Make", "Model", "Year", "Fuel", "Alloy", "Demand",
        "Offer Price", "Lead Status", "Created Date", "Last Activity", "Next Follow-up",
        "Deal Done", "Document Status", "File Approval Status", "Payment Status",
        "Payment Amount", "Payment Date", "COD Status", "Completed Date", "Remarks",
      ];
  const ws2 = XLSX.utils.json_to_sheet(rows, { header: headers });
  ws2["!cols"] = autoWidths(rows, headers);
  ws2["!freeze"] = { xSplit: 0, ySplit: 1 };
  XLSX.utils.book_append_sheet(wb, ws2, "Leads");

  const stamp = new Date().toISOString().slice(0, 10);
  const fname = `RVSF_Leads_${filters.month || stamp}.xlsx`;
  XLSX.writeFile(wb, fname);
  return fname;
}
